var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'style-role': _vm.isSuperAdminRole},style:(_vm.userStyle)},[_c('Sidebar'),_c('PopupZoomImage'),_c('UserSessionNotFound'),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }